import { createSlice } from "@reduxjs/toolkit";

const leavingSiteSlice = createSlice({
  name: "leavingSite",
  initialState: {
    url: "",
    showLeaveModal: false,
  },
  reducers: {
    leaveSiteHandler: (prevState, action) => {
      const state = prevState;
      if (action.payload.url) {
        state.url = action.payload.url;
      }
      state.showLeaveModal = true;
    },
    setShowLeaveModal: (prevState, action) => {
      const state = prevState;
      state.showLeaveModal = action.payload.showLeaveModal;
    },
  },
});

export const { leaveSiteHandler, setShowLeaveModal } = leavingSiteSlice.actions;

export const showLeaveModalSelector = (state) => state.leavingSite.showLeaveModal;
export const urlSelector = (state) => state.leavingSite.url;

export default leavingSiteSlice.reducer;
